interface AuthLayoutProps {
  children: React.ReactNode;
}

function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[var(--background)] via-[var(--background-subtle)] to-[var(--background)] flex flex-col">
      {/* Decorative background elements */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[var(--color-steel)]/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[var(--color-steel)]/3 rounded-full blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative flex-1 flex flex-col items-center justify-center px-4 py-12">
        {/* Logo & Branding */}
        <div className="flex flex-col items-center gap-4 mb-8">
          <div className="flex items-center justify-center w-20 h-20 rounded-2xl bg-[var(--card)] border border-[var(--border)] shadow-elevated">
            <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-12 h-12">
              <rect x="12" y="6" width="24" height="36" rx="4" stroke="var(--color-steel-dark)" strokeWidth="2.5" fill="none" />
              <path d="M24 18 L30 21 L24 24 L18 21 Z" fill="var(--color-steel)" stroke="var(--color-steel-dark)" strokeWidth="1.5" strokeLinejoin="round" />
              <path d="M18 21 L18 30 L24 33 L24 24 Z" fill="var(--color-steel-dark)" stroke="var(--color-steel-dark)" strokeWidth="1.5" strokeLinejoin="round" />
              <path d="M24 24 L24 33 L30 30 L30 21 Z" fill="var(--color-steel-hover)" stroke="var(--color-steel-dark)" strokeWidth="1.5" strokeLinejoin="round" />
            </svg>
          </div>
          <div className="text-center">
            <h1 className="text-3xl font-bold text-[var(--foreground)] text-shadow-subtle">VeloceInventory</h1>
            <p className="text-sm text-[var(--muted-foreground)] mt-1">Outil de gestion d'inventaire</p>
          </div>
        </div>

        {/* Auth card */}
        <div className="w-full max-w-md">{children}</div>
      </div>

      {/* Footer */}
      <footer className="relative py-4 text-center text-xs text-[var(--muted-foreground)]">
        <p>&copy; {new Date().getFullYear()} FMP InfoSolutions &middot; Version {__APP_VERSION__}</p>
      </footer>
    </div>
  );
}

export default AuthLayout;
